<template>
  <div class="d-flex flex-column article-card">
    <a :href="publication.SourceDomain">
      <span class="text-primary me-4 article-card_organization">{{publication.Source}}</span>
    </a>
    <a class="text-decoration-none" role="button" :href="publication.SourceUrl" target="_blank">
      <div class="d-flex align-items-center">
        <span class="m-0 d-flex article-card_title"><strong>{{publication.Title}}</strong></span>
        <i class="fa fa-external-link text-primary ms-3 fs-4 fw-normal normal"></i>
      </div>
      <div class="d-flex">
        <span class="text-primary">{{publication.Author}} | <span>{{publication.OriginalPublicationDate}}</span></span>
      </div>
      <div class="article-card_description" v-html="publication.Description"></div>
    </a>
  </div>

</template>
<script>

  export default {
    name: 'ArticleCard',
    props: {
      publication: {
        type: Object,
        required: true
      }
    },
  };
</script>
